import { render } from "./FangAnView.vue?vue&type=template&id=c35ba444&scoped=true&ts=true"
import script from "./FangAnView.vue?vue&type=script&lang=ts"
export * from "./FangAnView.vue?vue&type=script&lang=ts"

import "./FangAnView.vue?vue&type=style&index=0&id=c35ba444&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35ba444"]])

export default __exports__